import PregnancyCalculatorWidget from './PregnancyCalculatorWidget';
export { PREGNANCY_CALCULATOR_QUERY } from './hooks/use-pregnancy-calculator';

export default PregnancyCalculatorWidget;
